import { format, parseISO } from 'date-fns';

/** Dates arrive as yyyy-MM-dd. Parsing them as local avoids a timezone day-shift. */
export const toDisplayDate = (iso: string | null | undefined): string => {
  if (!iso) return '';
  try {
    return format(parseISO(iso), 'd MMM yyyy');
  } catch {
    return iso;
  }
};

/**
 * An interval with no end is open, and reads as such. Never a blank, and never a
 * sentinel date dressed up as real (C6).
 */
export const toIntervalLabel = (start: string, end: string | null): string =>
  `${toDisplayDate(start)} – ${end ? toDisplayDate(end) : 'today'}`;

export const plural = (n: number, one: string, many?: string): string =>
  `${n} ${n === 1 ? one : many ?? `${one}s`}`;
